import { SOCIAL_UPDATE } from "../apiEndpoint";
import { educationAxios } from "../http/http";

export default function socialAccountsUpdate(useremail, payload) {
  return educationAxios.put(`${SOCIAL_UPDATE}?user_email=${useremail}`, payload);
}
